<template>
  <div class="q-pa-md flex flex-center">
    <q-pagination
      v-model="pageSync"
      :max="total"
      :max-pages="maxPages"
      :boundary-numbers="true"
      :direction-links="total > maxPages"
    />
  </div>
</template>

<script>
export default {
  name: 'Pagination',

  props: {
    page: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },

  computed: {
    pageSync: {
      get() {
        return this.page;
      },
      set(value) {
        this.$emit('update:page', value);
      },
    },
    maxPages() {
      return 7;
    },
  },
};
</script>
